import {FC} from "react";
import PieCharts from "../PieCharts";
import Card from "../Card";
import {ProjectStatusData} from "@/@types/home";
import { PieChart } from "lucide-react";

interface ProjectStatusProps {
  projectStatusData: ProjectStatusData[] | undefined
}

const ProjectStatus: FC<ProjectStatusProps> = ({projectStatusData}) => {
  const legendItems = [
    { color: "#46d64b", label: "Projects with Shreds in Generation or Generated" },
    { color: "#6f6af8", label: "Projects with Shreds not Generated Yet" },
    { color: "#fac93f", label: "Projects without Shreds" },
    { color: "#fb372d", label: "Projects with Shreds that need some attention" }
  ];
  
  const EmptyChart = () => (
    <div className="flex flex-col items-center justify-center h-80">
      <PieChart className="w-16 h-16 text-gray-300 mb-4" />
      <p className="text-sm text-gray-500 text-center mb-2">
        No project status data available
      </p>
      <p className="text-xs text-gray-400 text-center max-w-[250px]">
        Project statistics will appear here once data is available
      </p>
    </div>
  );
  
  return (
    <Card borderColor="[#dbe0f6]" bgColor="white" minHeight="[510px]">
      <div className="p-5">
        <div className="flex justify-between items-center mb-4 max-w-[350px] m-auto">
          <h1 className="flex justify-between items-center text-xl font-bold w-full max-w-[180px]">
            <img src="/icons/loop.png" alt="Users" width={25} height={25}/>
            Project Status
          </h1>
        </div>
        
        <div className="relative w-full h-full max-h-[350px] max-w-[350px] m-auto">
          {projectStatusData && projectStatusData.length > 0 ? (
            <div className="flex justify-stretch items-stretch h-80">
              <PieCharts
                data={projectStatusData}
                innerRadius={60}
                outerRadius={100}
                fixedActive
                custom
              />
            </div>
          ) : (
            <EmptyChart />
          )}
        </div>
        
        <div className="space-y-2 max-w-[350px] m-auto">
          {legendItems.map((item, index) => (
            <div key={index} className="flex items-center text-sm font-semibold gap-3">
              <div
                className="h-3 w-3 rounded-full"
                style={{ backgroundColor: item.color }}
              />
              <span className={!projectStatusData || projectStatusData.length === 0 ? "text-gray-400" : ""}>
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
};

export default ProjectStatus;